module.exports = {
      id: "fallback-image-usage",
      viewBox: "0 0 102 76",
      url: __webpack_public_path__ + "svg-sprite-c16dead317bf40daa0a857495c90b974.svg#fallback-image",
      toString: function () {
        return this.url;
      }
    }